import _ from 'lodash'

import api from '@/api/api'
import Routes from '@/router/routes'

import ScrollTo from '@/components/general/scroll-to/scroll-to'
import MenuMoreOptions from '@/components/general/menu-more-options/menu-more-options'
import TextField from '@/components/general/fields/text/text'
import SelectField from '@/components/general/fields/select/select'

export default {
	name : 'sellers-types',
	data () {
		return {
			sellersTypes : [],
			menuOptions : [
				{
					iconClass : 'fa fa-pencil',
					name      : this.$t('private.sellers.sellers_types.menu_more_options.edit_seller_type'),
					action    : 'edit'
				},
				{
					iconClass : 'fa fa-trash',
					name      : this.$t('private.sellers.sellers_types.menu_more_options.delete_seller_type'),
					action    : 'delete'
				}
			],
			filters : {
				name : {
					id      : _.uniqueId('field_'),
					display : true,
					value   : '',
					name    : this.$t('private.sellers.sellers_types.filters.name'),
					type    : 'text',
					error   : false,
					filters : {
						type      : 'string',
						minLength : 2,
						maxLength : 100,
						required  : true
					},
					style     : {
						width : '230px',
						display : 'inline-block',
						margin : '0px 10px'
					}
				},
				ascending : {
					id        : _.uniqueId('field_'),
					display   : true,
					fakeValue : this.$t('private.sellers.sellers_types.filters.sort_options.created_at'),
					value     : 'createdAt',
					name      : this.$t('private.sellers.sellers_types.filters.sort_ascending'),
					error     : false,
					active    : false,
					options : [{
						fakeValue : this.$t('private.sellers.sellers_types.filters.sort_options.created_at'),
						value : 'createdAt'
					},{
						fakeValue : this.$t('private.sellers.sellers_types.filters.sort_options.name'),
						value : 'name'
					}],
					style     : {
						width : '230px',
						display : 'inline-block',
						margin : '0px 10px'
					}
				},
				descending : {
					id        : _.uniqueId('field_'),
					display   : true,
					fakeValue : '',
					value     : '',
					name      : this.$t('private.sellers.sellers_types.filters.sort_descending'),
					error     : false,
					active    : false,
					options : [{
						fakeValue : this.$t('private.sellers.sellers_types.filters.sort_options.created_at'),
						value : 'createdAt'
					},{
						fakeValue : this.$t('private.sellers.sellers_types.filters.sort_options.name'),
						value : 'name'
					}],
					style     : {
						width : '230px',
						display : 'inline-block',
						margin : '0px 10px'
					}
				},
				limit : {
					id        : _.uniqueId('field_'),
					display   : true,
					fakeValue : this.$t('private.sellers.sellers_types.filters.limit_options.10'),
					value     : 10,
					name      : this.$t('private.sellers.sellers_types.filters.limit'),
					error     : false,
					active    : false,
					options : [{
						fakeValue : this.$t('private.sellers.sellers_types.filters.limit_options.10'),
						value : 10
					},{
						fakeValue : this.$t('private.sellers.sellers_types.filters.limit_options.25'),
						value : 25
					},{
						fakeValue : this.$t('private.sellers.sellers_types.filters.limit_options.50'),
						value : 50
					},{
						fakeValue : this.$t('private.sellers.sellers_types.filters.limit_options.100'),
						value : 100
					}],
					style     : {
						width : '230px',
						display : 'inline-block',
						margin : '0px 10px'
					}
				},
				skip : {
					value : 0
				}
			},
			getSellersTypesActive : false,
			activateFilters : false,
			haveData : false,
			nextPage : false,
			formCreate : {
				fields : {
					name : {
						id      : _.uniqueId('field_'),
						display : true,
						value   : '',
						name    : this.$t('private.sellers.sellers_types.fields.name'),
						type    : 'text',
						error   : false,
						filters : {
							type      : 'string',
							minLength : 2,
							maxLength : 100,
							required  : true
						}
					}
				},
				active : false
			},
			displayCreateSellerType : false,
			formUpdate : {
				fields : {
					id : {
						value   : '',
						filters : {
							type      : 'string',
							required  : true
						}
					},
					name : {
						id      : _.uniqueId('field_'),
						display : true,
						value   : '',
						name    : this.$t('private.sellers.sellers_types.fields.name'),
						type    : 'text',
						error   : false,
						filters : {
							type      : 'string',
							minLength : 2,
							maxLength : 100,
							required  : true
						}
					}
				},
				active : false
			},
			displayUpdateSellerType : false
		}
	},
	methods : {
		getSellersTypes () {

			let vm = this

			vm.getSellersTypesActive = true
      vm.sellersTypes = []

        let dataToSend =
				'/?name='      + vm.filters.name.value        +
				'&ascending='  + vm.filters.ascending.value   +
				'&descending=' + vm.filters.ascending.value   +
				'&limit='      + (vm.filters.limit.value + 1) +
				'&skip='       + vm.filters.skip.value

			api
				.sellersTypes
				.getSellersTypes(dataToSend)
				.then( (response) => {

					vm.getSellersTypesActive = false

					if( response.status != 200 ){

						let message = {
							message : [vm.$t('errors.custom.001')],
							type    : 'error'
						}

						vm.$root.$emit('showMessage', message)

						return

					}

					if( !response.data.success ){

						let message = {
							message : [vm.$t('errors.custom.001')],
							type    : 'error'
						}

						vm.$root.$emit('showMessage', message)

						return

					}

					vm.sellersTypes = response.data.sellersTypes

					if( vm.sellersTypes.length > 0 && !vm.haveData ){

						vm.haveData = true

					}

					if( vm.sellersTypes.length > vm.filters.limit.value ){

						vm.nextPage = true

						vm.sellersTypes.pop()

					}else{

						vm.nextPage = false

					}


				})

		},
		goToBackPage () {

			let vm = this

			if( vm.filters.skip.value != 0 ){

				vm.filters.skip.value = vm.filters.skip.value - vm.filters.limit.value

				vm.getSellersTypes()

			}

		},
		goToNextPage () {

			let vm = this

			if( vm.nextPage ){

				vm.filters.skip.value = vm.filters.skip.value + vm.filters.limit.value

				vm.getSellersTypes()

			}

		},
		optionSelected (data) {

			let vm = this

			if( data.action == 'edit' ){

				vm.formUpdate.fields.id.value   = data.element.id
				vm.formUpdate.fields.name.value = data.element.name

				vm.displayUpdateSellerType = true

			}else if( data.action == 'delete' ){

				vm.deleteSellerType(data.element)

			}

		},
		formCreateSubmit () {

			let vm = this

			if( vm.formCreate.active ){

				return

			}

			vm.formCreate.active = true

			vm.$root.$emit('validate', [vm.formCreate.fields, (response) => {

				if( !response.success ){

					vm.formCreate.active = false

					response.type = 'error'

					response.field.error = true

					let dataToScroll = {
						selector : '#' + response.field.id,
						target   : 'html, body'
					}

					ScrollTo.submit(dataToScroll)

					vm.$root.$emit('showMessage', response)

					return

				}

				let dataToSend = {
					name : vm.formCreate.fields.name.value
				}

				api
					.sellersTypes
					.createSellerType(dataToSend)
					.then( (response) => {

						vm.formCreate.active = false

						if( response.status != 200 ){

							let message = {
								message : [vm.$t('errors.custom.001')],
								type    : 'error'
							}

							vm.$root.$emit('showMessage', message)

							return

						}

						if( !response.data.success ){

							if( response.data.error.code == 101 ){

								let message = {
									message : [vm.$t('errors.parse.101')],
									type    : 'error'
								}

								vm.$root.$emit('showMessage', message)

							}

							return

						}

						let message = {
							message : [vm.$t('private.sellers.sellers_types.create_success')],
							type    : 'success'
						}

						vm.$root.$emit('showMessage', message)

						vm.getSellersTypes()

						vm.displayCreateSellerType = false

						vm.formCreate.fields.name.value = ''

					});

			}])

		},
		formUpdateSubmit () {

			let vm = this

			if( vm.formUpdate.active ){

				return

			}

			vm.formUpdate.active = true

			vm.$root.$emit('validate', [vm.formUpdate.fields, (response) => {

				if( !response.success ){

					vm.formUpdate.active = false

					response.type = 'error'

					response.field.error = true

					let dataToScroll = {
						selector : '#' + response.field.id,
						target   : 'html, body'
					}

					ScrollTo.submit(dataToScroll)

					vm.$root.$emit('showMessage', response)

					return

				}

				let dataToSend = {
					id   : vm.formUpdate.fields.id.value,
					name : vm.formUpdate.fields.name.value
				}

				api
					.sellersTypes
					.updateSellerType(dataToSend)
					.then( (response) => {

						vm.formUpdate.active = false

						if( response.status != 200 ){

							let message = {
								message : [vm.$t('errors.custom.001')],
								type    : 'error'
							}

							vm.$root.$emit('showMessage', message)

							return

						}

						if( !response.data.success ){

							if( response.data.error.code == 101 ){

								let message = {
									message : [vm.$t('errors.parse.101')],
									type    : 'error'
								}

								vm.$root.$emit('showMessage', message)

							}

							return

						}

						let message = {
							message : [vm.$t('private.sellers.sellers_types.update_success')],
							type    : 'success'
						}

						vm.$root.$emit('showMessage', message)

						vm.displayUpdateSellerType = false

						vm.getSellersTypes()

						vm.formUpdate.fields.name.value = ''

					});

			}])

		},
		deleteSellerType (element) {

			let vm = this

			let questionModal = {
				title : this.$t('private.sellers.sellers_types.question_modal.title'),
				question : this.$t('private.sellers.sellers_types.question_modal.question')
			}

			vm.$root.$emit('question-modal', [questionModal, (response) => {

				if(response){

					let dataToSend = '/?id=' + element.id

					api
						.sellersTypes
						.deleteSellerType(dataToSend)
						.then( (response) => {

							vm.formUpdate.active = false

							if( response.status != 200 ){

								let message = {
									message : [vm.$t('errors.custom.001')],
									type    : 'error'
								}

								vm.$root.$emit('showMessage', message)

								return

							}

							if( !response.data.success ){

								if( response.data.error.code == 101 ){

									let message = {
										message : [vm.$t('errors.parse.101')],
										type    : 'error'
									}

									vm.$root.$emit('showMessage', message)

								}

								return

							}

							let message = {
								message : [vm.$t('private.sellers.sellers_types.delete_success')],
								type    : 'success'
							}

							vm.$root.$emit('showMessage', message)

							vm.getSellersTypes()

						});

				}

			}])

		}
	},
	components : {
		MenuMoreOptions,
		TextField,
		SelectField
	},
	created () {

		let vm = this

		vm.getSellersTypes()

	}
}



// WEBPACK FOOTER //
// ./src/components/private/sellers/sellers-types/script.js